var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { makeOuiaAttributes } from './Ouia';
var WithOuia = function (Component, params) {
    var type = typeof params === 'string' ? params : params.module ? "".concat(params.module, "/").concat(params.type) : params.type;
    var InnerComponent = typeof params !== 'string' && params.InnerComponent !== undefined ? params.InnerComponent : 'div';
    var withOuia = function (props) {
        var ouiaData = makeOuiaAttributes({
            fullType: type,
            ouiaId: props.ouiaId,
            ouiaSafe: props.ouiaSafe,
        });
        return (React.createElement(InnerComponent, __assign({}, ouiaData),
            React.createElement(Component, __assign({}, props), props.children)));
    };
    return withOuia;
};
export default WithOuia;
//# sourceMappingURL=WithOuia.js.map